<app-drawer
  #drawerComponent
  [drawerModel]="drawerData"
  [drawerConfig]="drawerInputConfig"
  [AddDataURL]="addDataUrl"
  [editDataURL]="editDataUrl"
  [createDrawerTitle]="'Create New PHI Record'"
  [updateDrawerTitle]="'Update PHI Record'"
  [hasTwoColumns]="true"
  [maxDrawerHeight]="'max-h-[450px]'"
  (refresh)="refreshHandler()"
  (resetData)="resetEntry()"
></app-drawer>
<app-dynamic-grid
  [gridConfig]="gridConfig"
  [getDataUrl]="getDataUrl"
  [toggleUrl]="toggleUrl"
  [sortBy]="'modifiedAt'"
  [sortOrder]="'desc'"
  (onToggleShowToastEmitter)="showToast($event)"
  (addClicked)="onAddHandler($event)"
  (editClicked)="onEditHandler($event)"
></app-dynamic-grid>
<app-toast></app-toast>
